import { commonPromise } from '../index.js'

const API_PROXY_PREFIX = ''
const BASE_URL = API_PROXY_PREFIX

const couponGoodsCopyApi = {
  couponGoodsCopyCouponPage: (data) => commonPromise({
    data,
    url: `${BASE_URL}/coupon/goodsCopy/couponPage`,
    method: 'post'
  }),
  couponGoodsCopySourceGoodsPage: (data) => commonPromise({
    data,
    url: `${BASE_URL}/coupon/goodsCopy/sourceGoodsPage`,
    method: 'post'
  }),
  couponGoodsCopyReplace: (data) => commonPromise({
    data,
    url: `${BASE_URL}/coupon/goodsCopy/replace`,
    method: 'post'
  })
}

export default couponGoodsCopyApi
